<template>
  <div>
    <span class="label" v-if="inTemplate">
      {{ active ? "Inactivar chatbot para editar" : "Activar chatbot" }}
    </span>

    <a-tooltip placement="bottom" :title="active ? 'Inactivar' : 'Activar'">
      <template #title>
        {{ 
          chatbotData?.deleted_queues ? 
          'Algunas colas fueron eliminadas, recuerda reemplazarlas para poder activar tu IVR.' :
          (active ? 'Inactivar' : 'Activar') }}
      </template>
      <a-switch
        name="chatbot-switch"
        :checked="active"
        :loading="loadingSwitch"
        :disabled="disabled"
        @change="handleChangeStatus(chatbotData.id)"
        size="small"
      />
    </a-tooltip>
  </div>

  <DisableChatbotModal
    v-if="actionModal.visible"
    :visible="actionModal.visible"
    :totalTickets="actionModal.total_tickets"
    :chatbot="chatbotData"
    @update="handleUpdate"
    @close="actionModal.visible = false"
  />
</template>

<script setup>
import { reactive, ref, computed } from "vue";
import { message } from "ant-design-vue";

import { changeChatbotStatus, fetchChatbotDetails, fetchNodes } from "@/app/chatbots/services";
import { ChatbotStatus } from "@/app/chatbots/utils/enums";

import DisableChatbotModal from "../modals/DisableChatbotModal.vue";
import { WarningFilled } from "@ant-design/icons-vue";

const props = defineProps({
  chatbotData: { type: Object, default: () => ({}) },
  inTemplate: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});
const emit = defineEmits(["update"]);

const loadingSwitch = ref(false);
const actionModal = reactive({
  visible: false,
  total_tickets: null,
});

const active = computed(() => props.chatbotData?.status === ChatbotStatus.Active);

const handleChangeStatus = async (id) => {
  loadingSwitch.value = true;

  const chatbotDetails = await fetchChatbotDetails(props.chatbotData?.id);

  if (active.value && chatbotDetails.total_tickets) {
    actionModal.visible = true;
    actionModal.total_tickets = chatbotDetails.total_tickets;
  } else if (!active.value) {
    const nodes = await fetchNodes(props.chatbotData.id);
    if (!nodes || nodes.length === 0) {
      message.error("No puedes activar el chatbot sin configurar al menos un nodo.");
      loadingSwitch.value = false;
      return;
    }
    try {
      const body = { status: ChatbotStatus.Active };
      await changeChatbotStatus(id, body);
      handleUpdate();
    } catch (error) {
      const errorMessage = error?.getErrorMessage() || "Error al activar el chatbot";
      message.error(errorMessage);
      console.log(error);
    }
  } else {
    try {
      const body = { status: active.value ? ChatbotStatus.Inactive : ChatbotStatus.Active };
      await changeChatbotStatus(id, body);
      handleUpdate();
    } catch (error) {
      const errorMessage = error?.getErrorMessage() || "Error al activar el chatbot";

      message.error(errorMessage);
      console.log(error);
    }
  }

  loadingSwitch.value = false;
};

const handleUpdate = () => emit("update");
</script>

<style lang="sass" scoped>
.label
  margin-right: 5px
  font-size: 12px
  color: $gray-8

// .floating
//   position: absolute
//   right: 0
//   top: 0
//   bottom: 0
//   margin: auto 0
//   display: flex
//   align-items: center
//   margin-right: 12px
</style>
